export default "__VITE_ASSET__ixdXCeIt__"